export default {
  contracts: [],
  currentExtract: [],
  isLoadingStatus: false,
  isLoadingContractDetails: false,
  error: null
}



// WEBPACK FOOTER //
// ./src/store/modules/combo_extract/state.js